export class RoutesUtils {
    static   toHoursAndMinutes(totalMinutes) {
        const minutes = totalMinutes % 60;
        const hours = Math.floor(totalMinutes / 60);
        return `${hours} h ${minutes > 0 ? ` ${minutes} m` : ''}`;
    }
}
